import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import * as Sentry from "@sentry/angular"
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DEV_ENV_NAME } from './constants/env';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                let error;
                if (err.error) {
                    error = err.error.message || err.error.detail
                } else {
                    error = err.statusText || err;
                }
                return throwError(error);
            })
        )
        .pipe(map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                if (event.body.responseCode == 401) {
                    this.router.navigateByUrl("/auth/login");
                } else if (event.body.responseCode == 500) {
                    if (event.body.error) {
                        const newError = new Error(event.body.error);
                        if (environment.envName === DEV_ENV_NAME) {
                            console.error("TSTERR intercept", newError);
                        } else {
                            console.error(newError);
                        }
                        Sentry.withScope(scope => {
                            scope.setExtra("errorExtraData", newError);
                            scope.setExtra("handlerSource", "interceptor");
                            if (environment.envName !== DEV_ENV_NAME) {
                                var eventId = Sentry.captureException(newError);
                            }
                        });
                        // Sentry.showReportDialog({
                        //     eventId: eventId,
                        // });
                    }
                } else if (event.status !== 200){
                    console.error("HTTP interceptor error", event.body.error || event);
                }
            }
            return event;
        }));
    }
}
